import React from 'react';
import cn from 'classnames';
import DataTable, { dataTableStyles } from '@dealroadshow/uikit-table/DataTable';
import IconAdd from '@dealroadshow/uikit-icon/IconAdd';

import Button, { ButtonVariantType } from '@dealroadshow/uikit-button';
import { IFinalFormFieldArrayInputComponentProps } from '@framework/ui/Organisms/FinalForm/interfaces';
import { ISpeakersTableRowItem } from './interfaces';
import { ISpeakerArrayItem } from '@evercall/domain/vo/call/SpeakerArrayItem';
import { getColumns } from './helpers';
import { useCallFormContext } from '../CallFormContext';

import cardStyles from '@dealroadshow/uikit-styles/card.module.scss';
import styles from './speakersTable.module.scss';

const SpeakersTable = (
  {
    fields,
    disabled,
  }: IFinalFormFieldArrayInputComponentProps<ISpeakerArrayItem>,
) => {
  const { isEvercall } = useCallFormContext();

  const addOneItem = () => fields.push({
    name: '',
    email: '',
  });
  const dataTable = fields.map<ISpeakersTableRowItem>((fieldName, fieldIndex) => (
    {
      fieldName,
      fieldIndex,
      className: styles.speakerField,
      ...fields.value[fieldIndex],
    }
  ));

  const orderCallback = (oldIndex, newIndex) => {
    if (newIndex !== 0) {
      fields.move(oldIndex, newIndex);
    }
  };

  return (
    <div className={ cn({ [styles.speakerTableContainer]: isEvercall }) }>
      <DataTable
        isDraggable
        className={ dataTableStyles.isSecondaryTable }
        dataTest="speakersDataTable"
        columns={ getColumns(fields, disabled) }
        data={ dataTable }
        isUsePureUpdateComponent
        orderCallback={ orderCallback }
      />
      <div className={ cardStyles.cardInnerHorizontal }>
        <Button
          variant={ ButtonVariantType.text }
          dataTest="speakersAddButton"
          disabled={ disabled }
          className={ cn(styles.addBtn) }
          onClick={ addOneItem }
        >
          <IconAdd />
          Add Speaker
        </Button>
      </div>
    </div>
  );
};

export default SpeakersTable;
